// src/components/CategoryCard.js

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import './CategoryCard.css'; // Asegúrate de tener el archivo CSS para los estilos

/**
 * Componente para mostrar una categoría como un enlace de texto simple.
 * @param {Object} props - Props del componente.
 * @param {Object} props.category - Objeto que representa la categoría.
 * @returns {JSX.Element} El enlace de la categoría.
 */
const CategoryCard = ({ category }) => {
    const navigate = useNavigate();

    // Determinar si la categoría es "Recomendados"
    const isRecommended = category.slug === 'recomendados';

    /**
     * Maneja el clic en la categoría "Recomendados".
     * Navega a la página de inicio con el estado 'reset' para reiniciar la búsqueda.
     * @param {Object} e - Evento de clic.
     */
    const handleRecommendedClick = (e) => {
        e.preventDefault(); // Prevenir la navegación por defecto
        navigate('/', { state: { reset: true } }); // Navegar a Home con estado reset
    };

    return (
        <div className="category-card">
            {isRecommended ? (
                // Si es "Recomendados", usar NavLink con manejador de clic
                <NavLink
                    to="/"
                    className={({ isActive }) =>
                        isActive ? 'category-link active' : 'category-link'
                    }
                    onClick={handleRecommendedClick}
                >
                    {category.name}
                </NavLink>
            ) : (
                // Para otras categorías, usar NavLink para la navegación
                <NavLink
                    to={`/category/${category.slug}`}
                    className={({ isActive }) =>
                        isActive ? 'category-link active' : 'category-link'
                    }
                >
                    {category.name}
                </NavLink>
            )}
        </div>
    );
};

export default CategoryCard;
